/* eslint-disable react/display-name */
import React from 'react';
import { Label } from 'ui/components/styled';

export const Timer = React.forwardRef(({ time = 30, hidden = false, onTimeEnd, ...rest }, ref) => {
  const [countdown, setCountdown] = React.useState(time);
  const interval = React.useRef();

  const startTimer = React.useCallback(
    (startFrom = countdown) => {
      let counter = startFrom;
      interval.current = setInterval(() => {
        counter--;
        setCountdown(counter);
        if (counter === 0) {
          counter = time;
          setCountdown(time);
          if (onTimeEnd) {
            onTimeEnd();
          }
        }
      }, 1000);
    },
    [time, onTimeEnd]
  );

  const stopTimer = () => {
    clearInterval(interval.current);
  };

  const resetTimer = () => {
    stopTimer();
    setCountdown(time);
    startTimer(time);
  };

  // allow us to call resetTimer from parent
  React.useImperativeHandle(ref, () => ({
    resetTimer,
  }));

  React.useEffect(() => {
    startTimer();
    return () => stopTimer();
  }, [startTimer]);

  return hidden ? null : (
    <Label {...rest} color="darkGrey" fontSize="14px" fontWeight="normal">
      Next refresh in: {countdown} second{countdown > 1 ? 's' : ''}
    </Label>
  );
});
